export default "__VITE_ASSET__BmSaEV5m__"